module.exports = __webpack_public_path__ + "images/zhiren-x-00a0558f1c4e4ee8e1e9edc97b65067a.png";